import axios from "axios";
import settings from "@/settings";
import store from "@/store";

const api = axios.create({
  baseURL: settings.apiBaseUrl,
  withCredentials: true,
});

api.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const status = error?.response.status;

    if (status >= 500 || (status === 401 && store.get("app/user") !== null)) {
      const errorCode =
        error?.response.status === 401 ? "unauthorized" : "unknown";
      return store
        .dispatch("app/raiseFatalError", errorCode)
        .then(() => Promise.reject(error));
    }
    return Promise.reject(error);
  }
);

export default api;
